import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 22 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 15.9854V11.9854M11 7.98535H11.01M21 11.9854C21 17.5082 16.5228 21.9854 11 21.9854C5.47715 21.9854 1 17.5082 1 11.9854C1 6.4625 5.47715 1.98535 11 1.98535C16.5228 1.98535 21 6.4625 21 11.9854Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgInfoCircle);
export default ForwardRef;
